(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glownovi-advent-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const product = JSON.parse(root.querySelector('[data-advent-product]').textContent);
    const form = root.querySelector('form[action*="/cart/add"]');
    const idInput = form.querySelector('[name="id"]');
    const select = form.querySelector('[data-variant-select]');
    const quantity = form.querySelector('[name="quantity"]');
    const add = form.querySelector('[data-add-to-cart]');
    const sticky = root.querySelector('[data-sticky]');
    const stickyAdd = root.querySelector('[data-sticky-add]');
    const error = form.querySelector('[data-form-error]');
    const status = form.querySelector('[data-cart-status]');
    const money = value => new Intl.NumberFormat(root.dataset.locale || 'en', {style:'currency',currency:root.dataset.currency}).format(value / 100);
    let pending = false;
    let current = product.variants.find(v => String(v.id) === idInput.value) || product.variants[0];
    const slides = [...root.querySelectorAll('[data-media-id]')];
    const thumbs = [...root.querySelectorAll('[data-thumbnail]')];
    let mediaIndex = Math.max(0, slides.findIndex(e => !e.hidden));
    function showMedia(index, announce = true) {
      if (!slides.length) return;
      mediaIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {slide.hidden = i !== mediaIndex;if (i !== mediaIndex) slide.querySelectorAll('video').forEach(v => v.pause());});
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === mediaIndex)));
      const thumb = thumbs[mediaIndex];
      if (thumb) {const rail=thumb.parentElement;rail.scrollLeft=thumb.offsetLeft-rail.offsetLeft-(rail.clientWidth-thumb.clientWidth)/2;}
      if (announce) root.querySelector('[data-gallery-status]').textContent = `Product media ${mediaIndex + 1} of ${slides.length}`;
    }
    thumbs.forEach((thumb,i) => thumb.addEventListener('click', () => showMedia(i)));
    root.querySelectorAll('[data-gallery-step]').forEach(b => b.addEventListener('click', () => showMedia(mediaIndex + Number(b.dataset.galleryStep))));
    const stage = root.querySelector('[data-gallery-stage]');
    stage.addEventListener('keydown', event => {if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();showMedia(mediaIndex + (event.key === 'ArrowRight' ? 1 : -1));}});
    let touchStart;
    stage.addEventListener('touchstart', e => {touchStart={x:e.touches[0].clientX,y:e.touches[0].clientY};},{passive:true});
    stage.addEventListener('touchend', e => {if (!touchStart) return;const dx=e.changedTouches[0].clientX-touchStart.x,dy=e.changedTouches[0].clientY-touchStart.y;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy))showMedia(mediaIndex+(dx<0?1:-1));touchStart=null;},{passive:true});
    function syncButtons(label) {
      const available = !!current?.available;
      add.disabled = pending || !available;
      add.setAttribute('aria-busy', String(pending));
      add.querySelector('[data-add-label]').textContent = label || (pending ? 'Adding…' : available ? 'Add to cart' : 'Sold out');
      if (stickyAdd) {stickyAdd.disabled = add.disabled;stickyAdd.setAttribute('aria-busy',String(pending));stickyAdd.textContent=label || (pending ? 'Adding…' : available ? 'Add to cart' : 'Sold out');}
    }
    function updateVariant() {
      current = product.variants.find(v => String(v.id) === (select?.value || idInput.value));
      if (!current) return;
      idInput.value = current.id;
      idInput.dispatchEvent(new Event('change',{bubbles:true}));
      root.querySelector('[data-price]').textContent = money(current.price);
      const sale = current.compare_at_price > current.price;
      const compare = root.querySelector('[data-compare]'),saving=root.querySelector('[data-saving]');
      compare.hidden=!sale;saving.hidden=!sale;
      compare.textContent=sale?money(current.compare_at_price):'';
      saving.textContent=sale?'Save '+money(current.compare_at_price-current.price):'';
      root.querySelector('[data-availability]').textContent=current.available?'In stock':'Sold out';
      if (sticky) sticky.querySelector('[data-sticky-price]').textContent=money(current.price);
      const rule=current.quantity_rule || {min:1,increment:1};
      quantity.min=rule.min || 1;quantity.step=rule.increment || 1;
      if (rule.max) quantity.max=rule.max;else quantity.removeAttribute('max');
      quantity.value=rule.min || 1;
      const slot=root.querySelector('[data-advent-app-slot]');slot.dataset.variantId=current.id;
      if(current.featured_media){const i=slides.findIndex(e=>String(e.dataset.mediaId)===String(current.featured_media.id));if(i>=0)showMedia(i);}
      error.hidden=true;syncButtons();
      const url=new URL(location.href);url.searchParams.set('variant',current.id);history.replaceState({},'',url);
      document.dispatchEvent(new CustomEvent('variant:change',{detail:{variant:current,productId:product.id}}));
    }
    select?.addEventListener('change',updateVariant);
    root.querySelectorAll('[data-quantity-step]').forEach(b=>b.addEventListener('click',()=>{if(b.dataset.quantityStep==='1')quantity.stepUp();else quantity.stepDown();quantity.dispatchEvent(new Event('input',{bubbles:true}));quantity.dispatchEvent(new Event('change',{bubbles:true}));}));
    quantity.addEventListener('change',()=>{if(Number(quantity.value)<Number(quantity.min))quantity.value=quantity.min;});
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      if(pending || !current?.available || !form.reportValidity())return;
      const submittedId=idInput.value;
      const data=new FormData(form);
      pending=true;error.hidden=true;status.textContent='Adding to your cart…';syncButtons();
      if(select)select.disabled=true;
      try {
        const route=window.Shopify?.routes?.root || '/';
        const response=await fetch(route+'cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json'}});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description || result.message || 'This item could not be added. Please try again.');
        status.textContent='Added to your cart.';
        form.querySelector('[data-view-cart]').hidden=false;
        syncButtons('Added ✓');
        try {const cart=await (await fetch(route+'cart.js',{headers:{Accept:'application/json'}})).json();document.querySelectorAll('[data-lm-cart-count],[data-cart-count]').forEach(e=>e.textContent=cart.item_count);}catch(_){}
        document.dispatchEvent(new CustomEvent('lm:product-added',{detail:{productId:product.id,variantId:submittedId}}));
      } catch(problem) {
        status.textContent='';error.textContent=problem.message || 'Unable to add this item. Please try again.';error.hidden=false;error.focus({preventScroll:false});
      } finally {pending=false;if(select)select.disabled=false;syncButtons();}
    });
    stickyAdd?.addEventListener('click',()=>form.requestSubmit(add));
    if(sticky){let scheduled=false;const updateSticky=()=>{scheduled=false;const main=add.getBoundingClientRect();const bottom=root.getBoundingClientRect().bottom;const active=document.activeElement;const rect=active?.getBoundingClientRect();const overlapsFocus=root.contains(active)&&!sticky.contains(active)&&rect&&rect.bottom>innerHeight-112&&rect.top<innerHeight;sticky.hidden=main.bottom>80||bottom<innerHeight||!!overlapsFocus;};window.addEventListener('scroll',()=>{if(!scheduled){scheduled=true;requestAnimationFrame(updateSticky);}},{passive:true});window.addEventListener('resize',updateSticky);root.addEventListener('focusin',updateSticky);root.addEventListener('focusout',()=>requestAnimationFrame(updateSticky));updateSticky();}
    const reduce=matchMedia('(prefers-reduced-motion: reduce)');
    const clips=[...root.querySelectorAll('.gn-advent__clip video')];
    const observeVideo=video=>{const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){if(video.dataset.videoSrc&&!video.src){video.src=video.dataset.videoSrc;video.load();}if(!reduce.matches&&video.dataset.userPaused!=='true')video.play().catch(()=>{});}else{video.dataset.outside='true';video.pause();}});},{rootMargin:'0px',threshold:.3});observer.observe(video);video.addEventListener('pause',()=>{if(video.dataset.outside==='true')delete video.dataset.outside;else video.dataset.userPaused='true';});video.addEventListener('play',()=>{delete video.dataset.userPaused;});};
    if('IntersectionObserver' in window)clips.forEach(observeVideo);
    reduce.addEventListener('change',()=>{if(reduce.matches)clips.forEach(v=>v.pause());});
    // The app owns offer radios, pricing, eligibility and discounts. Move its real node; never clone it.
    const appSlot=root.querySelector('[data-advent-app-slot]');
    const manualQuantity=root.querySelector('[data-manual-quantity]');
    const connectBundler=()=>{const widget=root.querySelector('.bndlr-quantity-break');if(widget&&appSlot&&!appSlot.contains(widget))appSlot.append(widget);if(manualQuantity)manualQuantity.hidden=!!widget;root.dataset.bundler=widget?'ready':'waiting';};
    const bundleObserver=new MutationObserver(connectBundler);bundleObserver.observe(root,{childList:true,subtree:true});connectBundler();
    syncButtons();
  }
  const start=()=>document.querySelectorAll('[data-advent]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glownovi-christmas-product"]) return;
  try {
    
  if (!customElements.get('gn-pdp-code')) {
    customElements.define('gn-pdp-code', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => { if (this.isConnected) this.bindCopy(); });
      }
      bindCopy() {
        const button = this.querySelector('button');
        if (!button) return;
        button.hidden = false;
        button.onclick = async () => {
          const code = this.querySelector('.gn-pdp-offer__code');
          const label = this.querySelector('[data-gn-copy-label]');
          const status = this.querySelector('[role="status"]');
          clearTimeout(this.resetTimer);
          button.disabled = true;
          status.textContent = '';
          try {
            const text = code.textContent.trim();
            let copied = false;
            if (window.self !== window.top) copied = this.copyWithSelection(text);
            if (!copied) {
              try {
                await navigator.clipboard.writeText(text);
                copied = true;
              } catch {
                copied = this.copyWithSelection(text);
              }
            }
            if (!copied) throw new Error('Clipboard unavailable');
            label.textContent = 'Copied';
            status.textContent = code.textContent.trim() + ' copied. Paste it at checkout.';
          } catch {
            label.textContent = 'Copy';
            const range = document.createRange();
            range.selectNodeContents(code);
            const selection = window.getSelection();
            if (selection) { selection.removeAllRanges(); selection.addRange(range); }
            status.textContent = 'Copy unavailable. Select ' + code.textContent.trim() + ' and copy it manually.';
          } finally {
            button.disabled = false;
            if (document.activeElement === document.body && this.isConnected) button.focus({ preventScroll: true });
            this.resetTimer = setTimeout(() => { label.textContent = 'Copy'; }, 3000);
          }
        };
      }
      copyWithSelection(text) {
        const field = document.createElement('textarea');
        field.value = text;
        field.readOnly = true;
        field.tabIndex = -1;
        field.setAttribute('aria-hidden', 'true');
        field.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;opacity:0;font-size:16px;pointer-events:none;';
        this.appendChild(field);
        try {
          field.focus({ preventScroll: true });
          field.select();
          field.setSelectionRange(0, text.length);
          return document.execCommand('copy') === true;
        } catch {
          return false;
        } finally {
          field.remove();
        }
      }
      disconnectedCallback() { clearTimeout(this.resetTimer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glownovi-halloween-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gn-pdp-code')) {
    customElements.define('gn-pdp-code', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => { if (this.isConnected) this.bindCopy(); });
      }
      bindCopy() {
        const button = this.querySelector('button');
        if (!button) return;
        button.hidden = false;
        button.onclick = async () => {
          const code = this.querySelector('.gn-pdp-offer__code');
          const label = this.querySelector('[data-gn-copy-label]');
          const status = this.querySelector('[role="status"]');
          clearTimeout(this.resetTimer);
          button.disabled = true;
          status.textContent = '';
          try {
            const text = code.textContent.trim();
            let copied = false;
            if (window.self !== window.top) copied = this.copyWithSelection(text);
            if (!copied) {
              try {
                await navigator.clipboard.writeText(text);
                copied = true;
              } catch {
                copied = this.copyWithSelection(text);
              }
            }
            if (!copied) throw new Error('Clipboard unavailable');
            label.textContent = 'Copied';
            status.textContent = code.textContent.trim() + ' copied. Paste it at checkout.';
          } catch {
            label.textContent = 'Copy';
            const range = document.createRange();
            range.selectNodeContents(code);
            const selection = window.getSelection();
            if (selection) { selection.removeAllRanges(); selection.addRange(range); }
            status.textContent = 'Copy unavailable. Select ' + code.textContent.trim() + ' and copy it manually.';
          } finally {
            button.disabled = false;
            if (document.activeElement === document.body && this.isConnected) button.focus({ preventScroll: true });
            this.resetTimer = setTimeout(() => { label.textContent = 'Copy'; }, 3000);
          }
        };
      }
      copyWithSelection(text) {
        const field = document.createElement('textarea');
        field.value = text;
        field.readOnly = true;
        field.tabIndex = -1;
        field.setAttribute('aria-hidden', 'true');
        field.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;opacity:0;font-size:16px;pointer-events:none;';
        this.appendChild(field);
        try {
          field.focus({ preventScroll: true });
          field.select();
          field.setSelectionRange(0, text.length);
          return document.execCommand('copy') === true;
        } catch {
          return false;
        } finally {
          field.remove();
        }
      }
      disconnectedCallback() { clearTimeout(this.resetTimer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glownovi-promo-popup"]) return;
  try {
    
  if (!customElements.get('glownovi-promo')) {
    customElements.define('glownovi-promo', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.editor = this.dataset.editor === 'true';
        this.cookieName = 'glownovi_promo_seen';
        this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
        this.dialog.addEventListener('close', () => {
          if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
        }, options);
        this.querySelector('[data-copy]').addEventListener('click', () => this.copyCode(), options);
        window.addEventListener('pagehide', () => {
          clearTimeout(this.timer);
          if (this.dialog.open) this.dialog.close();
        }, options);
        window.addEventListener('pageshow', event => {
          if (event.persisted) this.schedule();
        }, options);
        document.addEventListener('shopify:section:select', event => {
          if (this.editor && event.target.contains(this)) this.show();
        }, options);
        this.schedule();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.dialog?.open) this.dialog.close();
        this.controller?.abort();
        this.controller = null;
      }
      excluded() {
        return /\/(cart|checkout|checkouts)(\/|$)/i.test(location.pathname);
      }
      seen() {
        try { return document.cookie.split(';').some(value => value.trim() === this.cookieName + '=1'); }
        catch { return true; }
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.excluded() || (!this.editor && this.seen())) return;
        this.timer = setTimeout(() => this.show(), 2500);
      }
      show() {
        if (!this.isConnected || this.dialog.open || this.excluded() || (!this.editor && this.seen())) return;
        if (document.hidden || document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]')) {
          this.timer = setTimeout(() => this.show(), 1000);
          return;
        }
        if (!this.editor) {
          try {
            document.cookie = this.cookieName + '=1; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
            if (!this.seen()) return;
          } catch { return; }
        }
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
      }
      async copyCode() {
        const button = this.querySelector('[data-copy]');
        const input = this.querySelector('input');
        const status = this.querySelector('[data-status]');
        button.disabled = true;
        status.textContent = '';
        try {
          await navigator.clipboard.writeText(input.value);
          status.textContent = status.dataset.success;
          this.querySelector('.gn-promo__coupon').setAttribute('data-copied', '');
        } catch {
          input.focus();
          input.select();
          input.setSelectionRange(0, input.value.length);
          status.textContent = status.dataset.failure;
        } finally {
          button.disabled = false;
          if (this.dialog.open && document.activeElement !== input) button.focus({ preventScroll: true });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bundle-glownovi"]) return;
  try {
    
  if (!customElements.get('gn-pdp-code')) {
    customElements.define('gn-pdp-code', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => { if (this.isConnected) this.bindCopy(); });
      }
      bindCopy() {
        const button = this.querySelector('button');
        if (!button) return;
        button.hidden = false;
        button.onclick = async () => {
          const code = this.querySelector('.gn-pdp-offer__code');
          const label = this.querySelector('[data-gn-copy-label]');
          const status = this.querySelector('[role="status"]');
          clearTimeout(this.resetTimer);
          button.disabled = true;
          status.textContent = '';
          try {
            const text = code.textContent.trim();
            let copied = false;
            if (window.self !== window.top) copied = this.copyWithSelection(text);
            if (!copied) {
              try {
                await navigator.clipboard.writeText(text);
                copied = true;
              } catch {
                copied = this.copyWithSelection(text);
              }
            }
            if (!copied) throw new Error('Clipboard unavailable');
            label.textContent = 'Copied';
            status.textContent = code.textContent.trim() + ' copied. Paste it at checkout.';
          } catch {
            label.textContent = 'Copy';
            const range = document.createRange();
            range.selectNodeContents(code);
            const selection = window.getSelection();
            if (selection) { selection.removeAllRanges(); selection.addRange(range); }
            status.textContent = 'Copy unavailable. Select ' + code.textContent.trim() + ' and copy it manually.';
          } finally {
            button.disabled = false;
            if (document.activeElement === document.body && this.isConnected) button.focus({ preventScroll: true });
            this.resetTimer = setTimeout(() => { label.textContent = 'Copy'; }, 3000);
          }
        };
      }
      copyWithSelection(text) {
        const field = document.createElement('textarea');
        field.value = text;
        field.readOnly = true;
        field.tabIndex = -1;
        field.setAttribute('aria-hidden', 'true');
        field.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;opacity:0;font-size:16px;pointer-events:none;';
        this.appendChild(field);
        try {
          field.focus({ preventScroll: true });
          field.select();
          field.setSelectionRange(0, text.length);
          return document.execCommand('copy') === true;
        } catch {
          return false;
        } finally {
          field.remove();
        }
      }
      disconnectedCallback() { clearTimeout(this.resetTimer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('gn-pdp-code')) {
    customElements.define('gn-pdp-code', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => { if (this.isConnected) this.bindCopy(); });
      }
      bindCopy() {
        const button = this.querySelector('button');
        if (!button) return;
        button.hidden = false;
        button.onclick = async () => {
          const code = this.querySelector('.gn-pdp-offer__code');
          const label = this.querySelector('[data-gn-copy-label]');
          const status = this.querySelector('[role="status"]');
          clearTimeout(this.resetTimer);
          button.disabled = true;
          status.textContent = '';
          try {
            const text = code.textContent.trim();
            let copied = false;
            if (window.self !== window.top) copied = this.copyWithSelection(text);
            if (!copied) {
              try {
                await navigator.clipboard.writeText(text);
                copied = true;
              } catch {
                copied = this.copyWithSelection(text);
              }
            }
            if (!copied) throw new Error('Clipboard unavailable');
            label.textContent = 'Copied';
            status.textContent = code.textContent.trim() + ' copied. Paste it at checkout.';
          } catch {
            label.textContent = 'Copy';
            const range = document.createRange();
            range.selectNodeContents(code);
            const selection = window.getSelection();
            if (selection) { selection.removeAllRanges(); selection.addRange(range); }
            status.textContent = 'Copy unavailable. Select ' + code.textContent.trim() + ' and copy it manually.';
          } finally {
            button.disabled = false;
            if (document.activeElement === document.body && this.isConnected) button.focus({ preventScroll: true });
            this.resetTimer = setTimeout(() => { label.textContent = 'Copy'; }, 3000);
          }
        };
      }
      copyWithSelection(text) {
        const field = document.createElement('textarea');
        field.value = text;
        field.readOnly = true;
        field.tabIndex = -1;
        field.setAttribute('aria-hidden', 'true');
        field.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;opacity:0;font-size:16px;pointer-events:none;';
        this.appendChild(field);
        try {
          field.focus({ preventScroll: true });
          field.select();
          field.setSelectionRange(0, text.length);
          return document.execCommand('copy') === true;
        } catch {
          return false;
        } finally {
          field.remove();
        }
      }
      disconnectedCallback() { clearTimeout(this.resetTimer); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
